import React from 'react';
import { Heart } from 'lucide-react';
import { ProgressBar } from './ProgressBar';
import { StatSection } from './StatSection';

interface CivilStatusStatsProps {
  civilStatusStats: {
    soltero: number;
    soltera: number;
    casado: number;
    casada: number;
    viudo: number;
    viuda: number;
    divorciado: number;
    divorciada: number;
  };
  totalMembers: number;
}

export const CivilStatusStats: React.FC<CivilStatusStatsProps> = ({
  civilStatusStats,
  totalMembers
}) => {
  const hasOthers = civilStatusStats.viudo + civilStatusStats.viuda + 
                    civilStatusStats.divorciado + civilStatusStats.divorciada > 0;

  return (
    <StatSection title="Distribución por Estado Civil" icon={Heart} iconColor="text-pink-500">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="space-y-4">
          <h4 className="font-medium text-gray-700 mb-4">Estados principales</h4>
          <ProgressBar
            label="Solteros"
            value={civilStatusStats.soltero}
            total={totalMembers}
            color="#6366f1"
          />
          <ProgressBar
            label="Solteras"
            value={civilStatusStats.soltera}
            total={totalMembers}
            color="#ec4899"
          />
          <ProgressBar
            label="Casados"
            value={civilStatusStats.casado}
            total={totalMembers}
            color="#10b981"
          />
          <ProgressBar
            label="Casadas"
            value={civilStatusStats.casada}
            total={totalMembers}
            color="#f59e0b"
          />
        </div>
        
        {hasOthers && (
          <div className="space-y-4">
            <h4 className="font-medium text-gray-700 mb-4">Otros estados</h4>
            <ProgressBar
              label="Viudos"
              value={civilStatusStats.viudo}
              total={totalMembers}
              color="#f97316"
            />
            <ProgressBar
              label="Viudas"
              value={civilStatusStats.viuda}
              total={totalMembers}
              color="#ef4444"
            />
            <ProgressBar
              label="Divorciados"
              value={civilStatusStats.divorciado}
              total={totalMembers}
              color="#8b5cf6"
            />
            <ProgressBar
              label="Divorciadas"
              value={civilStatusStats.divorciada}
              total={totalMembers}
              color="#06b6d4"
            />
          </div>
        )}
      </div>
    </StatSection>
  );
};

export default CivilStatusStats;
